import { request } from '@/api/_base'

export const createQrcode = async () => {
  return await request({
    url: `/api/v1/qrcode/create`
  })
}

export const statusQrcode = async (qrcodeid) => {
  return await request({
    url: `/api/v1/qrcode/status`,
    params: {
      qrcodeid,
    }
  })
}